export enum GlobalSearchItemType {
  CLIENT = 'CLIENT',
  CONTRACTOR = 'CONTRACTOR',
  EMPLOYEE = 'EMPLOYEE',
}

type BaseItem = {
  id: string;
  itemType: GlobalSearchItemType;
  name: string;
};

type GlobalSearchClient = BaseItem & {
  itemType: GlobalSearchItemType.CLIENT;
  externalId: string;
};

type GlobalSearchContractor = BaseItem & {
  itemType: GlobalSearchItemType.CONTRACTOR;
};

type GlobalSearchEmployee = BaseItem & {
  itemType: GlobalSearchItemType.EMPLOYEE;
  clientId: string;
  clientName: string | undefined;
  country: string;
};

export type GlobalSearchItem =
  | GlobalSearchClient
  | GlobalSearchContractor
  | GlobalSearchEmployee;

export type GetGlobalSearchItemsResponse = {
  items: GlobalSearchItem[];
  lastUpdatedAt: { clients: string; contractors: string; employees: string };
};
